import { Building, Home, Network, Ticket } from "lucide-react";
import { createElement } from "react";
import type { TFunction } from "i18next";
import { ROUTES } from "@/app/routes";
import type { DropdownNavItem, NavItem } from "../hooks/useNavState";

export function buildDefaultNavItems(t: TFunction): NavItem[] {
  return [
    {
      path: ROUTES.DASHBOARD,
      icon: createElement(Home, { size: 16 }),
      label: t("nav.dashboard"),
    },
  ];
}

export function buildDefaultOperationsNavItems(t: TFunction): NavItem[] {
  return [
    {
      path: ROUTES.BENEFICIARIES.LIST,
      icon: createElement(Ticket, { size: 16 }),
      label: t("nav.beneficiaries"),
    },
  ];
}

export function buildDefaultOperationsDropdowns(t: TFunction): DropdownNavItem[] {
  return [
    {
      path: ROUTES.INVESTMENTS.MAIN,
      icon: createElement(Network, { size: 16 }),
      label: t("nav.investments"),
      children: [
        {
          path: ROUTES.INVESTMENTS.CALCULATOR,
          label: t("nav.calculator"),
        },
        { path: ROUTES.INVESTMENTS.INVESTORS, label: t("nav.investors") },
        { path: ROUTES.INVESTMENTS.MAIN, label: t("nav.investments") },
        { path: ROUTES.INVESTMENTS.CONTRACTS, label: t("nav.contracts") },
      ],
    },
  ];
}

export function buildDefaultManagementDropdowns(t: TFunction): DropdownNavItem[] {
  return [
    {
      path: ROUTES.ORGANIZATION.GENERAL,
      icon: createElement(Building, { size: 16 }),
      label: t("nav.organization"),
      children: [
        {
          path: "/organization/general",
          label: t("organization.tabs.general"),
        },
        {
          path: ROUTES.ORGANIZATION.USERS,
          label: t("organization.tabs.users"),
        },
        {
          path: ROUTES.ORGANIZATION.TEMPLATES,
          label: t("organization.tabs.templates"),
        },
      ],
    },
  ];
}
